import Dashboard from "../Components/DashboardMenu/Dashboard";

const DashboardPage = () => {
  return <Dashboard />;
};

export default DashboardPage;
